import {
    Component,
    OnInit,
    OnChanges,
    AfterContentChecked,
    Input,
    SimpleChanges,
    OnDestroy,
} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AppServices } from '../../../shared/services';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { CommonServices } from '../../../shared/services/src/api';
import * as _ from 'lodash';
import { EnvUtils, RouterUtils, StringUtils } from '../../../shared/utils';
import { Subscription } from 'rxjs/Subscription';
import { AuthServices } from '../../../shared/authentications/src/auth.services';
import { LanguageUtils } from '../../../shared/utils/src/language.utils';
import { StorageUtils } from '../../../shared/utils/src/storage.utils';
import { EnvServices } from '../../../shared/services';
import { EnvLoadService } from '../../../env-load/env-load.service';
import { TeamServices } from '../../../shared/services/src/api/team.services';
import { LocalStorageService } from 'angular-2-local-storage';
import { KeycloakloginService } from '../../../shared/services';
import { IntegratedKeycloakloginService } from '../../../shared/services';
import { initPosthogTracking } from '../../../shared/services/src/3rdPartyScript/posthog-tracking';

const header = require('./header');

@Component({
    selector: 'app-main-header',
    templateUrl: './header.component_new.html',
    styleUrls: ['../../../../_asset/sources/assets/styles/@scss/@layout/_console_gnb.scss']
})

export class HeaderComponent implements OnInit, OnChanges, AfterContentChecked, OnDestroy {
    homepageInfo: any = {};
    @Input() loginUser: any = { 'userId': '', 'userNm': '' };

    userCompanyList: any[] = [];
    selectedCompanyName: string;
    selectedCompanyId: string;
    serviceList: any[] = [{ 'svcId': '', 'svcNm': '', 'authTypeCd': '' }];
    svcMenuList: any[] = [{ 'svcId': '', 'svcNm': '', 'actnUrl': '' }];
    itsMenuList: any[] = [{ 'svcId': '', 'svcNm': '', 'actnUrl': '' }];
    recentMenuList: any[] = [{ 'svcId': '', 'svcNm': '', 'actnUrl': '', 'menuUrl': '', 'menuNm': '' }];
    subDomain: string;
    portalUrl: string;
    cmpnMenuAuth: string;
    securityMenuAuth: string;
    @Input() curLang;
    cmpnId = '';
    isReady = false;
    noticeList: any;
    noticeScrollDataList: any;
    notReadNoticeCount: string;
    changeCompanyFlag = false;
    cmpnDiffFlag = false;
    private browserTimeZone: string;
    public noticeListData = false;
    // zendeskUseFlag = false;
    private subscription: Subscription;

    urls: any;

    isIncident = false;
    isService = false;
    isEscalation = false;
    // isConfiguration = false;
    isIntegration = false;
    isExtension = false;
    isChangeHistory = false;
    isNotiHistory = false;
    isPersonalsetting = false;
    isTeam = false;
    isSchedule = false;
    isUser = false;
    isSystemReport = false;
    isIncidentReport = false;
    isNotiReport = false;
    isUserReport = false;
    isGuide = false;
    isNotice = false;
    isProfile = false;
    isRunbook = false;
    isSendNotice = false;

    isRunbookTemplate = false;
    isRunbookCredential = false;
    isRunbookHistory = false;


    teamUseYN;

    trialYn = 'N';
    trialRemainDays = '0';

    selectedMenuId = 'OSN010';
    envType = 'Global';

    // isSamsungDemo = false;

    public pageTitleConfig: any = {
        pageTitle: 'MK.00907',
        menuTitle: []
    };

    serviceName: any = true;
    goToBack: any = false;
    helpLink: any = true;

    constructor(public _route: Router,
        private appServices: AppServices,
        private translate: TranslateService,
        private _commonServices: CommonServices,
        public teamServices: TeamServices,
        private localStorageService: LocalStorageService,
        public envServices: EnvServices,
        public authService: AuthServices,
        private _envServices: EnvServices,
        private keycloakloginService: KeycloakloginService,
        private integratedKeycloakloginService: IntegratedKeycloakloginService,
        private _envLoadService: EnvLoadService) {
        this.urls = appServices.getUrls();

        _route.events.forEach((event) => {
            if (event instanceof NavigationEnd) {
                const pathname = event.url.split('/');
                this.whatIsSelected(pathname);
            }
        });

        if (global['teamUseYN']) {
            this.getTeamList();
        }
    }

    ngOnInit(): void {
        /*this.trialYn = global['loginUser'].trialYn;
        this.trialRemainDays = global['loginUser'].trialRemainDays;

        if (this.trialYn === 'Y' && this.trialRemainDays === '0') {
            // this.movePortal('/dashboard'); // 현재 위치에서 ${global['PORTAL_URL']} 값이 undefined 임.
            //location.href = environment.portalUrl;
            location.href = this._envLoadService.portalUrl;
        }*/
        // this.zendeskUseFlag = this.envServices.getZendeskUseFlag();
        this.envType = this.envServices.getServiceLocale();

        this.browserTimeZone = moment().format('Z');


        this.subscription = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
            this.curLang = event.lang;
            if (this.loginUser && this.loginUser.userId && this.selectedCompanyId) {
                this.selectCompany(this.selectedCompanyId);
            }
        });

        setTimeout(function () {
            header.ConsoleGNB.init();
        }, 1);

        this.setSubDomain();

        let userLang;

        userLang = LanguageUtils.getLangCode();
        userLang = /(en|ko|zh|ja)/gi.test(userLang) ? userLang : 'en';
        $('html').attr('lang', userLang);

        //const portalUrl = environment.portalUrl;
        const portalUrl = this._envLoadService.portalUrl;
        const opsnow360Url = this._envLoadService.opsnow360Url;
        global['PORTAL_URL'] = portalUrl.substr(0, (portalUrl.length - 1));
        global['OPSNOW360_URL'] = opsnow360Url.substr(0, (opsnow360Url.length - 1));

        const pathname = window.location.pathname.split('/');
        this.whatIsSelected(pathname);
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.loginUser && this.loginUser.userId) {
            this.getUserCompanyList();
        }

        this.getHomepageInfo();
    }

    // 앵귤러의 변경이 감지가 완료되면 호출됨
    ngAfterContentChecked() {
        const serviceList = $('.menu-scroll > ul >li.selected button').attr('class');
        const $serviceFold = $('.service-fold');
        $serviceFold.find('.' + serviceList + '').removeAttr('hidden');


        if (global['loginUser'].cmpnId && global['loginUser'].cmpnId !== this.cmpnId) {
            this.isReady = false;
        }
        if (!this.isReady && global['loginUser'] && global['loginUser'].userId && global['loginUser'].cmpnId) {
            this.isReady = true;
            this.cmpnId = global['loginUser'].cmpnId;
            this.getNoReadNotice();
        }
    }

    private getUserCompanyList() {
        this._commonServices.getCompanyList()
            .then(resp => {
                if (resp.status === 200) {
                    const result = resp.json();
                    this.userCompanyList = result.data.cmpnList;

                    setTimeout(function () {
                        header.ConsoleGNB.setCompany();
                    }, 1);
                    this.cmpnDiffFlag = false;
                    if (global['loginUser'].curCmpnId && _.find(this.userCompanyList, { cmpnId: global['loginUser'].curCmpnId })) {
                        if (global['loginUser'].curCmpnId !== global['loginUser'].compCurCmpnId) {
                            this.cmpnDiffFlag = true;
                        }
                        this.selectCompany(global['loginUser'].curCmpnId);
                        return;
                    }

                    if (this.userCompanyList.length > 0) {
                        this.selectCompany(this.userCompanyList[0].cmpnId);
                    }
                }
            });
    }

    public changeCompany(id) {
        $('.btn-companies').removeClass('selected');
        this.changeCompanyFlag = true;

        // 챗봇에서 회사명 변경 시 사용하는 쿠키 생성(cc)
        $.cookie('cc', StringUtils.getUuid(), { domain: LanguageUtils.getSubDomain(), expires: 365, path: '/' });

        // 삼성 데모 체크
        //this.checkSamsungDemo(id);       삼성을 제외한 회사에도 서비스오픈

        this.selectCompany(id);
    }

    public selectCompany(id) {
        $('#company_search_word').val('').trigger('keyup');
        this.selectedCompanyId = id;
        this._commonServices.updateLastSelectCompany(id)
            .then(resp => {
                if (resp.status === 200) {
                    global['loginUser'].curCmpnId = id;
                }
            });

        this.selectedCompanyName = _.find(this.userCompanyList, { 'cmpnId': id }).cmpnNm;
        global['loginUser'].cmpnUtcTmzn = _.find(this.userCompanyList, { 'cmpnId': id }).cmpnUtcTmzn;

        sessionStorage.removeItem('alertnow_tracking_initialized');
        initPosthogTracking(this.selectedCompanyName);
        // this._commonServices.getMenuList(id, this.curLang).then(resp => {
        this._commonServices.getEarthMenuList(id).then(resp => {
            if (resp.status === 200) {
                const result = resp.json();
                const companyInfo: any = result.data.cmpnList[0];
                this.setServiceList(companyInfo.service);
                this.setShortCutMenu(companyInfo.service);
                global['loginUser'].cmpnId = id;
            }

            if (this.changeCompanyFlag || this.cmpnDiffFlag) {
                //세션 재조회
                this.appServices.getSession()
                    .then(rslt => {
                        global['loginUser'].curCmpnId = id;
                        const rolePrms = global['userRole'].rolePrms;
                        const teamUse = _.find(rolePrms, { 'rsrcTypeCd': 'PRMS_RSRC_010', 'rsrcPathVal': 'obj.team.**', 'actnId': '*' });
                        this.teamUseYN = global['teamUseYN'] = teamUse === undefined ? false : true;
                        this.teamServices.setTeamUseBool(global['teamUseYN']);

                        if (global['teamUseYN']) {
                            this.getTeamList();

                            const _data = {
                                'type': 'TT004',
                                'no': '',
                                'teamNoUseYn': 'N'
                            };

                            StorageUtils.setItem('alertNow.team', JSON.stringify(_data));
                            try {
                                // this.renderer.removeClass(this.myTeamTitle.nativeElement , 'on');
                                // this.renderer.removeClass(this.otherTeamTitle.nativeElement , 'on');
                            } catch (e) {
                                console.log(e);
                            }
                        } else {
                            StorageUtils.removeItem('alertNow.team');
                        }
                    }).then(() => {
                        const option = {
                            pathname: window.location.pathname
                        };

                        if (this.changeCompanyFlag) {
                            this.changeCompanyFlag = false;
                            RouterUtils.navigate(this._route, '/reload', option);
                        }
                    });
            }
        });
    }

    getTeamList() {
        global['teamData'] = {
            AllTeam: {
                default: {
                    dispNm: 'MK.00013',
                    teamNo: ''
                }
            },
            MyTeam: {
                default: {
                    dispNm: 'MK.01135',
                    teamNo: ''
                },
                list: [],
                count_bak: 0,
                count: 0
            },
            OtherTeam: {
                default: {
                    dispNm: 'MK.01233',
                    teamNo: ''
                },
                list: [],
                count_bak: 0,
                count: 0
            },
            UNASSIGNED: {
                default: {
                    dispNm: 'MK.01090',
                    teamNo: ''
                }
            }
        };

        let queryString = '';
        queryString += 'page=1';
        queryString += '&rows=10000';
        queryString += '&oidx=dispNm:asc';

        const myTeamQueryString = queryString + '&type=TT001';
        this._commonServices.getTeamList(myTeamQueryString).then(result => {
            if (result.status === 200) {
                global['teamData'].MyTeam.list = result.json().data;
                global['teamData'].MyTeam.default.teamNo = '';
                global['teamData'].MyTeam.count = global['teamData'].MyTeam.count_bak = global['teamData'].MyTeam.list.length;
            }
        });

        const otherTeamQueryString = queryString + '&type=TT002';
        this._commonServices.getTeamList(otherTeamQueryString).then(result => {
            if (result.status === 200) {
                global['teamData'].OtherTeam.list = result.json().data;
                global['teamData'].OtherTeam.default.teamNo = '';
                global['teamData'].OtherTeam.count = global['teamData'].OtherTeam.count_bak = global['teamData'].OtherTeam.list.length;
            }
        });
    }

    setServiceList(serviceList) {
        global['availableSvc'] = serviceList;

        this.serviceList = serviceList;
        const portal: any = _.find(serviceList, { 'svcId': 'portal' });
        //const alertnow: any = _.find(serviceList, {'svcId': 'osn'});

        /*        if (alertnow.guideYn === 'Y' && this.authService.isMenuAuthenticate('obj.guide')) {
                    RouterUtils.navigate(this._route, this.urls.guide);
                }*/
        if (portal) {
            global['PORTAL_URL'] = portal.svcUrl; //portal.actnUrl;
        }


        setTimeout(function () {
            header.ConsoleGNB.setServiceList();
        }, 1);
    }

    setShortCutMenu(serviceList) {
        this.svcMenuList = [];
        this.itsMenuList = [];
        this.cmpnMenuAuth = '';
        this.securityMenuAuth = '';

        for (const svcItem of serviceList) {
            if (_.includes(['portal', 'asset', 'metering', 'monitoring'], svcItem.svcId)) {
                if (svcItem.svcId === 'portal') {
                    for (const menuItem of svcItem.menuList) {
                        if (menuItem.menuId === 'SP900') {
                            this.cmpnMenuAuth = menuItem.authTypeCd;
                        }

                        if (menuItem.menuId === 'SP950') {
                            this.securityMenuAuth = menuItem.authTypeCd;
                        }
                    }
                    svcItem.menuList = _.reject(svcItem.menuList, { menuId: 'SP900' });
                    svcItem.menuList = _.reject(svcItem.menuList, { menuId: 'SP950' });
                    global['PORTAL_MENU_AUTH'] = svcItem.menuList;
                    this.svcMenuList.push(svcItem);
                } else {
                    if (svcItem.svcId === 'asset') {
                        global['ASSET_MENU_AUTH'] = svcItem.menuList;
                    }
                    this.svcMenuList.push(svcItem);
                }
            } else {
                this.itsMenuList.push(svcItem);
            }
        }
    }


    logout() {
        const tokenKey = EnvUtils.envCdToTokenKey();
        $.cookie(tokenKey, null, { domain: global['sub_domain'], expires: -1 });

        const refreshKey = EnvUtils.envCdToRefreshKey();
        $.cookie(refreshKey, null, { domain: global['sub_domain'], expires: -1 });

        this.integratedKeycloakloginService.logout({ 'redirectUri': global['logOutUrl'] });
    }

    // 타서비스 메뉴로 이동
    moveServiceMenu(menuFullUrl) {
        location.href = menuFullUrl;
    }

    movePortal(menuUrl) {
        location.href = `${global['OPSNOW360_URL']}${menuUrl}`;
    }

    moveProfile(_event) {
        this.routeTo(_event, 'profile');
    }

    getHomepageInfo() {
        this._commonServices.getHomePageInfo().then(resp => {
            if (resp.status === 200) {
                global['logOutUrl'] = resp.json().data.availableSvc ? resp.json().data.availableSvc.find((svc) => (svc.svcId === 'portal')).svcUrl : null;

                const result = resp.json();
                this.homepageInfo = result;

                $('#home_login_gnb_logo img').attr('src', '/');

                const subdomain = window.location.host.split('.')[0];
                if (subdomain === 'alertnowdev') {
                    //document.title = '[DEV] OpsNow - AlertNow';
                    document.title = this.homepageInfo['data'].svc.svcDmnTitl;
                } else if (subdomain === 'alertnowdqa') {
                    document.title = '[DQA] OpsNow - AlertNow';
                } else {
                    document.title = this.homepageInfo['data'].svc.svcDmnTitl;
                }

                const logo = this.homepageInfo['data'].logo;
                if (logo.mspCmpnLogoTypeCd === 'MSP_CMPN_LOGO_TYPE_010') {
                    $('#home_login_gnb_logo > img').attr('src', `${logo.logoGnbLogin}`);
                } else {
                    $('#home_login_gnb_logo').html(logo.logoGnbText);
                }
            }
        });
    }

    getNoticeList() {
        const postData: any = {
            'browserTimeZone': this.browserTimeZone
        };

        this._commonServices.getNotiList()
            .then(res => {
                if (res.status === 200) {
                    const result = res.json().data;
                    for (const data of result.data) {
                        data.creaDt = moment(data.creaDt).format('YYYY.MM.DD');
                        data.updtDt = moment(data.updtDt).format('YYYY.MM.DD');
                        //data.ntceType = 'view_header_notice_type_' + data.ntceType; Todo개선필요
                        if (data.ntceType === 'event') {
                            data.ntceTypeNm = 'MK.00564';
                        } else if (data.ntceType === 'check') {
                            data.ntceTypeNm = 'MK.00565';
                        } else if (data.ntceType === 'new') {
                            data.ntceTypeNm = 'MK.00566';
                        }
                    }
                    this.noticeList = result.data;

                    if (this.noticeList.length === 0) {
                        this.noticeListData = true;
                    }
                    $('.notification-container').show();
                }
            })
            .catch(err => {
            });
    }

    getNoReadNotice() {
        this._commonServices.getScrolltext()
            .then(res => {
                if (res.status === 200) {
                    const result = res.json().data;
                    if (Number(result.notReadNtce) > 99) {
                        this.notReadNoticeCount = '99+';
                    } else {
                        this.notReadNoticeCount = result.notReadNtce;
                    }

                    for (const data of result.data) {
                        data.updtDt = moment(data.updtDt).format('YYYY.MM.DD');

                        if (data.ntceType === 'event') {
                            data.ntceTypeNm = 'MK.00564';
                        } else if (data.ntceType === 'check') {
                            data.ntceTypeNm = 'MK.00565';
                        } else if (data.ntceType === 'new') {
                            data.ntceTypeNm = 'MK.00566';
                        }
                    }
                    this.noticeScrollDataList = result.data;
                }
            })
            .catch(err => { });
    }

    moveNoticeView(_event, ntceId) {
        _event.preventDefault();
        const params = {
            noticeId: ntceId
        };
        RouterUtils.navigate(this._route, '/notice/detail/', params);
    }

    moveNoticeList() {
        RouterUtils.navigate(this._route, '/notice/list');

    }

    private setSubDomain() {
        const subDomain: string[] = window.location.href.replace('http://', '').replace('https://', '').split('/')[0].split(':')[0].split('.');
        subDomain[0] = '';
        this.subDomain = subDomain.join('.');
    }

    moveSupportRequest(_event) {
        _event.preventDefault();
        //window.open(`${environment.supportUrl}/requests`);
        window.open(`${this._envLoadService.supportUrl}`);
    }

    whatIsSelected(pathname) {
        this.isIncident = this.isService = this.isEscalation = this.isIntegration = this.isExtension = this.isChangeHistory = this.isNotiHistory = this.isPersonalsetting
            = this.isTeam = this.isSchedule = this.isSystemReport = this.isIncidentReport = this.isNotiReport = this.isUserReport = this.isUser = this.isGuide = this.isNotice = this.isProfile = this.isSendNotice
            = this.isRunbookTemplate = this.isRunbookCredential = this.isRunbookHistory = false;

        this.selectedMenuId = 'OSN010';
        this.pageTitleConfig.menuTitle = [];
        this.goToBack = false;

        const depth1 = pathname[1];
        const depth2 = pathname[2];
        const option = pathname[3] ? pathname[3].indexOf('detail') : -1;
        switch (depth1) {
            case '':
            case 'incident':
                this.isIncident = true;
                this.selectedMenuId = 'OSN010';
                if (depth2 === 'alert') {
                    this.pageTitleConfig = {
                        pageTitle: 'MK.00907',
                        menuTitle: [
                            { title: 'MK.00907', url: '/incident/incident/' + encodeURIComponent('{"viewType":"list"}') },
                            { title: 'MK.00908', url: '/incident/alert/' + encodeURIComponent('{"viewType":"list"}'), selected: 'true' }
                        ]
                    };
                } else {
                    this.pageTitleConfig = {
                        pageTitle: 'MK.00907',
                        menuTitle: [
                            { title: 'MK.00907', url: '/incident/incident/' + encodeURIComponent('{"viewType":"list"}'), selected: 'true' },
                            { title: 'MK.00908', url: '/incident/alert/' + encodeURIComponent('{"viewType":"list"}') }
                        ]
                    };
                }
                if (option !== -1) {
                    this.goToBack = true;
                }
                if (depth2 === 'incident') {
                    this.maybeShowAlertNowPopupOnIncident();
                }
                break;
            case 'service':
                this.isService = true;
                this.selectedMenuId = 'OSN020'; // 환경 설정
                if (depth2 === 'new') {
                    this.pageTitleConfig.pageTitle = 'MK.00167';
                    this.goToBack = true;
                } else if (depth2 === 'detail') {
                    this.pageTitleConfig.pageTitle = 'MK.00909';
                    this.goToBack = true;
                } else {
                    this.pageTitleConfig.pageTitle = 'MK.00909';
                }
                break;
            case 'escalation':
                this.isEscalation = true;
                this.selectedMenuId = 'OSN020';
                if (depth2 === 'create-policy') {
                    this.pageTitleConfig.pageTitle = 'MK.00756';
                    this.goToBack = true;
                } else if (depth2 === 'modify-policy') {
                    this.pageTitleConfig.pageTitle = 'MK.00398';
                    this.goToBack = true;
                } else if (depth2 === 'duplicate-policy') {
                    this.pageTitleConfig.pageTitle = 'MK.00399';
                    this.goToBack = true;
                } else {
                    this.pageTitleConfig.pageTitle = 'MK.00910';
                    if (depth2 && depth2.indexOf('detail') !== -1) {
                        this.goToBack = true;
                    }
                }
                break;
            case 'integration':
                this.isIntegration = true;
                this.selectedMenuId = 'OSN020';
                if (depth2 === 'new') {
                    this.pageTitleConfig.pageTitle = 'MK.00283';
                    this.goToBack = true;
                } else if (depth2 === 'detail') {
                    this.pageTitleConfig.pageTitle = 'MK.00911';
                    this.goToBack = true;
                } else {
                    this.pageTitleConfig.pageTitle = 'MK.00911';
                }
                break;
            case 'extension':
                this.isExtension = true;
                this.selectedMenuId = 'OSN020';
                this.pageTitleConfig.pageTitle = 'MK.00912';
                this.goToBack = true;
                if (depth2 === 'edit') {
                    this.pageTitleConfig.pageTitle = 'MK.01045';
                } else if (depth2 === 'copy') {
                    this.pageTitleConfig.pageTitle = 'MK.01044';
                } else if (depth2 === 'new') {
                    this.pageTitleConfig.pageTitle = 'MK.01038';
                } else {
                    this.pageTitleConfig.pageTitle = 'MK.00912';
                    this.goToBack = false;
                }
                break;
            case 'change-history':
                this.isChangeHistory = true;
                this.selectedMenuId = 'OSN020';
                this.pageTitleConfig.pageTitle = 'MK.01731';
                break;
            case 'noti-history':
                this.isNotiHistory = true;
                this.selectedMenuId = 'OSN020';
                this.pageTitleConfig.pageTitle = 'MK.01782';
                break;
            case 'team':
                this.isTeam = true;
                this.selectedMenuId = 'OSN020';
                this.pageTitleConfig.pageTitle = 'MK.01130';
                if (depth2 === 'detail') {
                    this.goToBack = true;
                }
                break;
            case 'analytics':
                this.selectedMenuId = 'OSN070';
                if (depth2 === 'system') {
                    this.isSystemReport = true;
                    this.pageTitleConfig.pageTitle = 'MK.01451';
                } else if (depth2 === 'sysview') {
                    this.isSystemReport = true;
                    this.pageTitleConfig.pageTitle = 'MK.01461';
                    this.goToBack = true;
                } else if (depth2 === 'incident') {
                    this.isIncidentReport = true;
                    this.pageTitleConfig.pageTitle = 'MK.01545';
                } else if (depth2 === 'inctview') {
                    this.isIncidentReport = true;
                    this.pageTitleConfig.pageTitle = 'MK.01461';
                    this.goToBack = true;
                } else if (depth2 === 'notification') {
                    this.isNotiReport = true;
                    this.pageTitleConfig.pageTitle = 'MK.01546';
                } else if (depth2 === 'notiview') {
                    this.isNotiReport = true;
                    this.pageTitleConfig.pageTitle = 'MK.01559';
                    this.goToBack = true;
                } else {
                    this.isUserReport = true;
                }
                break;
            case 'personalsetting':
                this.isPersonalsetting = true;
                this.selectedMenuId = 'OSN060';
                this.pageTitleConfig.pageTitle = 'MK.00913';
                break;
            case 'schedule':
                this.isSchedule = true;
                this.selectedMenuId = 'OSN020';
                if (depth2 === 'edit') {
                    this.pageTitleConfig.pageTitle = 'MK.01415';
                    this.goToBack = true;
                } else if (depth2 === 'copy') {
                    this.pageTitleConfig.pageTitle = 'MK.01487';
                    this.goToBack = true;
                } else if (depth2 === 'new') {
                    this.pageTitleConfig.pageTitle = 'MK.01376';
                    this.goToBack = true;
                } else if (depth2 === 'detail') {
                    this.pageTitleConfig.pageTitle = 'MK.01375';
                    this.goToBack = true;
                } else {
                    this.pageTitleConfig.pageTitle = 'MK.01375';
                }
                break;
            case 'user':
                this.isUser = true;
                this.selectedMenuId = 'OSN020';
                this.pageTitleConfig.pageTitle = 'MK.01436';
                if (depth2 === 'detail') {
                    this.goToBack = true;
                }
                break;
            case 'guide':
                this.isGuide = true;
                this.selectedMenuId = 'OSN080';
                this.pageTitleConfig.pageTitle = 'MK.01825';
                break;
            case 'notice':
                this.isNotice = true;
                this.selectedMenuId = '';
                this.pageTitleConfig.pageTitle = 'MK.00971';
                this.helpLink = false;
                if (depth2 === 'detail') {
                    this.goToBack = true;
                }
                break;
            case 'profile':
                this.isProfile = true;
                this.selectedMenuId = '';
                this.pageTitleConfig.pageTitle = 'MK.00567';
                this.helpLink = false;
                break;
            case 'runbook':
                this.selectedMenuId = 'OSN100';
                this.pageTitleConfig.pageTitle = 'MK.02100';
                if (depth2 === 'template') {
                    this.isRunbookTemplate = true;
                    this.pageTitleConfig.pageTitle = 'MK.02101';
                } else if (depth2 === 'credential') {
                    this.isRunbookCredential = true;
                    this.pageTitleConfig.pageTitle = 'MK.02102';
                    this.goToBack = true;
                } else if (depth2 === 'history') {
                    this.isRunbookHistory = true;
                    this.pageTitleConfig.pageTitle = 'MK.02103';
                }
                this.goToBack = true;
                break;
            case 'sendnotice':
                this.isSendNotice = true;
                this.selectedMenuId = 'OSN090';
                this.pageTitleConfig.pageTitle = 'MK.02069';
                break;
        }
    }

    goBack() {
        history.go(-1);
    }

    routeTo(event, type) {
        const isControlClick = event.ctrlKey || event.metaKey;

        event.preventDefault();
        //event.stopPropagation();

        //하위에 있는 클래스를 모조리 제거하고 클릭 대상만 클래스를 붙임
        let option;
        let url = '';
        const curCmpnId = global['loginUser'].curCmpnId;

        switch (type) {
            case 'incident':
                option = {
                    curCmpnId: curCmpnId,
                    viewType: 'list'
                };
                url = this.urls.incident.incident;
                break;
            case 'configuration':
                option = {
                    curCmpnId: curCmpnId
                };
                url = this.urls.service.list;
                break;
            case 'service':
                option = {
                    curCmpnId: curCmpnId
                };
                url = this.urls.service.list;
                break;
            case 'escalation':
                option = {
                    curCmpnId: curCmpnId,
                    viewType: 'list'
                };
                url = this.urls.escalation;
                break;
            case 'integration':
                option = {
                    curCmpnId: curCmpnId,
                };
                url = this.urls.integration.list;
                break;
            case 'extension':
                option = {
                    curCmpnId: curCmpnId,
                };
                url = this.urls.extension.list;
                break;
            case 'change-history':
                url = this.urls.changehistory;
                break;
            case 'noti-history':
                url = this.urls.notihistory;
                break;
            case 'team':
                option = {
                    curCmpnId: curCmpnId
                };
                url = this.urls.team;
                break;
            case 'personalsetting':
                option = {
                    curCmpnId: curCmpnId,
                };
                url = this.urls.personalsetting.myinformation;
                break;
            case 'index':
                url = this.urls.index;
                break;
            case 'schedule':
                url = this.urls.schedule.list;
                break;
            case 'user':
                url = this.urls.user.list;
                break;
            case 'guide':
                url = this.urls.guide;
                break;
            case 'notice':
                url = this.urls.notice.list;
                break;
            case 'profile':
                url = this.urls.profile;
                break;
            case 'sendnotice':
                option = {
                    curCmpnId: curCmpnId,
                    viewType: 'list'
                };
                url = this.urls.sendnotice;
                break;
        }

        if (isControlClick) {
            RouterUtils.newWindow(url, option);
        } else {
            RouterUtils.navigate(this._route, url, option);
        }
    }

    locationTo(event, type) {
        const isControlClick = event.ctrlKey || event.metaKey;
        event.preventDefault();
        let url = '';

        switch (type) {
            case 'analytics.system':
                url = this.urls.analytics.system;
                break;
            case 'analytics.incident':
                url = this.urls.analytics.incident;
                break;
            case 'analytics.notification':
                url = this.urls.analytics.notification;
                break;
            case 'analytics.user':
                url = this.urls.analytics.user;
                break;
            case 'noti-template.list':
                url = this.urls.notitemplate.list;
                break;
            case 'runbook.template':
                url = this.urls.runbook.template;
                break;
            case 'runbook.credential':
                url = this.urls.runbook.credential;
                break;
            case 'runbook.history':
                url = this.urls.runbook.history;
                break;

        }
        location.href = location.origin.indexOf('alertnowdqa') > -1 ? 'https://alertnowdev.opsnow.com' : location.origin + RouterUtils.makeUrl(url);
    }

    routeToRecent(event, menuUrl) {
        let type = '';
        switch (menuUrl) {
            case '/incident/incident':
                type = 'incident'; break;
            case '/service/list':
                type = 'service'; break;
            case '/analytics/system':
                type = 'analytics.system'; break;
            case '/personalsetting/my-information':
                type = 'personalsetting'; break;
        }
        this.routeTo(event, type);
    }

    openSubMenu(event) {
        const data_depth = event.target.parentElement.parentElement.getAttribute('data-depth');
        event.target.parentElement.parentElement.setAttribute('data-depth', data_depth === 'on' ? 'off' : 'on');
    }

    showGuide() {
        const userLang = LanguageUtils.getLangCode();

        window.open(`${global['urlInfo'].portalUrl}docs/alertnow/${userLang}/user-guide-alertnow-${userLang}.html`);
    }

    moveAPI() {
        const hostname = location.hostname;
        let url: string;

        if (hostname.indexOf('sec-alertnow') > -1) {
            url = 'https://alertnowapidoc.sec-alertnow.com/swagger-ui/index.html';
        } else if (hostname.indexOf('local') > -1 || hostname.indexOf('dev') > -1 || hostname.indexOf('dqa') > -1) {
            url = 'https://alertnowapidocdev.an.opsnow.com/swagger-ui/index.html';
        } else {
            url = 'https://alertnowapidoc.an.opsnow.com/swagger-ui/index.html';
        }

        window.open(url);
    }

    moveSupport(_event) {
        _event.preventDefault();
        //window.open(environment.supportUrl);
        window.open(this._envLoadService.supportUrl);
    }

    clickRecentMenu() {
        // event.preventDefault();
        const userLang = LanguageUtils.getLangCode();
        this._commonServices.getRecentMenu(userLang).then(result => {
            if (result.status === 200) {
                this.recentMenuList = result.json().data;
            } else {
                console.error('recentmenu error');
            }
        });
    }

    selectSvcMenu(svcId, svcUrl?) {
        if (svcId === 'recently') {
            this.clickRecentMenu();
        } else if (svcId === 'whatap') {
            window.open(svcUrl);
            return;
        }

        // 자동 펼침으로 바뀌어서 사용 X
        // const resizeWidth = $('.layout-wrap')[0].offsetWidth;
        // if (resizeWidth > 1628 /*&& resizeWidth < 2212*/) {
        //     $('.layout-wrap').css('padding-left', '292px');
        // }

        $('.menu-wrapper').attr('data-open', 'open');

        $('.menu-scroll').find('button[class=' + svcId + ']').parent('li').addClass('selected');
        $('.menu-scroll').find('button[class!=' + svcId + ']').parent('li').removeClass('selected');

        $('.service-fold').find('div[class=' + svcId + ']').removeAttr('hidden');
        $('.service-fold').find('div[class!=' + svcId + ']').attr('hidden', true);
    }

    menuClose() {
        $('.menu-scroll').find('button[class=osn]').parent('li').addClass('selected');
        $('.menu-scroll').find('button[class!=osn]').parent('li').removeClass('selected');
    }

    onMouseEnterBtn(event, svcNm) {
        event.stopPropagation();
        event.target.setAttribute('title', svcNm);
    }

    onMouseLeaveBtn(event) {
        event.stopPropagation();
        event.target.removeAttribute('title');
    }

    // Alertnow 2.0 handlers
    openBetaAside() {
        $.magnificPopup.open({
            items: {
                src: '#newalertnowapplication',
            },
        });
    }

    openAlertNowBeta() {
        $.magnificPopup.close();
        const env = process.env.NODE_ENV;
        const hostname = window.location.hostname;
        if (env == 'localhost') {
            window.open('https://appdev.alertnow.io', '_blank');
        } else {
            window.open('https://' + hostname + '/v2', '_blank');
        }
    }

    private maybeShowAlertNowPopupOnIncident() {
        try {
            const dismissed = $.cookie('an2_incident_dismissed') === 'Y';
            if (!dismissed) {
                this.openBetaAside();
            }
        } catch (e) {
            // ignore
        }
    }

    dismissAlertNowBeta() {
        $.cookie('an2_incident_dismissed', 'Y', { domain: LanguageUtils.getSubDomain(), expires: 365, path: '/' });
        $.magnificPopup.close();
    }

}



// WEBPACK FOOTER //
// ./src/app/components/GNB/header/header.component.ts